export default {
  default: {
    reviewTitle: 'Review #{id}',
  },
}
